import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

/* Layout */
import Layout from '../views/layout/Layout'

/**
 * hidden: true                   if `hidden:true` will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu, whatever its child routes length
 *                                if not set alwaysShow, only more than one route under the children
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noredirect           if `redirect:noredirect` will no redirct in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
    title: 'title'               the name show in submenu and breadcrumb (recommend set)
    icon: 'svg-name'             the icon show in the sidebar,
  }
 **/
export const constantRouterMap = [
  {path: '/login', component: () => import('@/views/login/index'), hidden: true},
  {path: '/404', component: () => import('@/views/404'), hidden: true},
  {
    path: '',
    component: Layout,
    redirect: '/home',
    children: [
      {
      path: 'home',
      name: 'home',
      component: () => import('@/views/home/index'),
      meta: {title: '首页', icon: 'home'}
    },
    {
      path: 'StockNotice',
      name: 'StockNotice',
      component: () => import('@/views/home/StockNotice'),
      meta: {title: '缺货登记'},
      hidden:true
    },
    {
      path: 'UserInfo',
      name: 'UserInfo',
      component: () => import('@/views/home/UserInfo'),
      meta: {title: '账号信息'},
      hidden:true
    },
    ]
  },
]

export const asyncRouterMap = [
  {
    path: '/bms',
    component: Layout,
    redirect: '/bms/shop',
    name: 'bms',
    meta: {title: '油站 ', icon: 'product'},
    children: [{
      path: 'shop',
      name: 'shop',
      component: () => import('@/views/bms/shop/index'),
      meta: {title: '油站列表', icon: 'product-list'}

    },
      {
        path: 'addShop',
        name: 'addShop',
        component: () => import('@/views/bms/shop/add'),
        meta: {title: '添加油站', icon: 'product-add'},
        hidden: true
      },
      {
        path: 'updateShop',
        name: 'updateShop',
        component: () => import('@/views/bms/shop/update'),
        meta: {title: '添加油站', icon: 'product-add'},
        hidden: true
      },
      {
        path: 'shopDetail',
        name: 'shopDetail',
        component: () => import('@/views/bms/shop/ShopDetail'),
        meta: {title: '油站详情', icon: 'product-add'},
        hidden: true
      },
      {
        path: 'shopDeviceList',
        name: 'shopDeviceList',
        component: () => import('@/views/bms/device/index'),
        meta: {title: '设备列表', icon: 'product-add'},
        hidden: true
      },
      {
        path: 'shopMemberList',
        name: 'shopMemberList',
        component: () => import('@/views/bms/member/index'),
        meta: {title: '员工列表', icon: 'product-add'},
        hidden: true
      },
      {
        path: 'addShopMember',
        name: 'addShopMember',
        component: () => import('@/views/bms/member/add'),
        meta: {title: '添加员工', icon: 'product-add'},
        hidden: true
      },
      {
        path: 'updateShopMember',
        name: 'updateShopMember',
        component: () => import('@/views/bms/member/update'),
        meta: {title: '编辑员工', icon: 'product-add'},
        hidden: true
      },
      {
        path: 'shopActList',
        name: 'shopActList',
        component: () => import('@/views/bms/activity/index'),
        meta: {title: '优惠活动列表', icon: 'product-add'},
        hidden: true
      },
      {
        path: 'addShopAct',
        name: 'addShopAct',
        component: () => import('@/views/bms/activity/add'),
        meta: {title: '添加优惠活动', icon: 'product-add'},
        hidden: true
      },
      {
        path: 'updateShopAct',
        name: 'updateShopAct',
        component: () => import('@/views/bms/activity/update'),
        meta: {title: '更新优惠活动', icon: 'product-add'},
        hidden: true
      },
      {
        path: 'oilCardList',
        name: 'oilCardList',
        component: () => import('@/views/bms/oilcard/index'),
        meta: {title: '油卡列表', icon: 'product-add'},
        hidden: true
      },


      {
        path: 'integralMemberList',
        name: 'integralMemberList',
        component: () => import('@/views/bms/integraMember/index'),
        meta: {title: '积分会员'},
        hidden:true
      },
	  {
	    path: 'shopShiftList',
	    name: 'shopShiftList',
	    component: () => import('@/views/bms/shopShift/index'),
	    meta: {title: '班次列表', icon: 'product-add'},
	    hidden: true
	  },

	  ]
  },
  {
    path: '/pmsOil',
    component: Layout,
    redirect: '/pmsOil/oilList',
    name: 'pmsOil',
    meta: {title: '油品 ', icon: 'product'},
    children: [{
      path: 'OilProductList',
      name: 'OilProductList',
      component: () => import('@/views/pms/oil/product/index'),
      meta: {title: '油品列表', icon: 'product-list'}
    },
      {
        path: 'addOilProduct',
        name: 'addOilProduct',
        component: () => import('@/views/pms/oil/addOilProduct'),
        meta: {title: '添加油品', icon: 'product-add'},
        hidden: true
      },
      {
        path: 'updateOilProduct',
        name: 'updateOilProduct',
        component: () => import('@/views/pms/oil/updateOilProduct'),
        meta: {title: '编辑油品', icon: 'product-add'},
        hidden: true
      },
      {
        path: 'oilGunList',
        name: 'oilGunList',
        component: () => import('@/views/pms/oil/gun/OilGunList'),
        meta: {title: '油枪列表', icon: 'product-add'},
        hidden: true
      },
      {
        path: 'addOilGun',
        name: 'addOilGun',
        component: () => import('@/views/pms/oil/gun/addOilGun'),
        meta: {title: '添加油枪', icon: 'product-add'},
        hidden: true
      },
      {
        path: 'updateOilGun',
        name: 'updateOilGun',
        component: () => import('@/views/pms/oil/gun/updateOilGun'),
        meta: {title: '添加油枪', icon: 'product-add'},
        hidden: true
      },
      ]
  },

  {
    path: '/vip',
    component: Layout,
    redirect: '/vip/member',
    name: 'vipmember',
    meta: {title: '会员 ', icon: 'product'},
    children: [
      {
        path: 'list',
        name: 'oilCardShowMember',
        component: () => import('@/views/bms/cardMember/showCardMember'),
        meta: {title: '充卡会员列表', icon: 'product-list'}
      },
      {
        path: 'oilCardMemberInfo',
        name: 'oilCardMemberInfo',
        component: () => import('@/views/bms/cardMember/userDetail'),
        meta: {title: '会员详情'},
        hidden:true
      },
      {
        path: 'oilCardMemberList',
        name: 'oilCardMemberList',
        component: () => import('@/views/bms/cardMember/index'),
        meta: {title: '会员列表', icon: 'product-list'},
        hidden: true
      },
      {
        path: 'oilCardMemberActList',
        name: 'oilCardMemberActList',
        component: () => import('@/views/bms/cardMember/activity/index'),
        meta: {title: '充卡活动', icon: 'product-add'},
        hidden: true
      },
      {
        path: 'addCardAct',
        name: 'addCardAct',
        component: () => import('@/views/bms/cardMember/activity/add'),
        meta: {title: '添加充卡活动', icon: 'product-add'},
        hidden: true
      },
      {
        path: 'updateCardAct',
        name: 'updateCardAct',
        component: () => import('@/views/bms/cardMember/activity/update'),
        meta: {title: '添加充卡活动', icon: 'product-add'},
        hidden: true
      },
      {
        path: 'oilCardBalanceExchangeList',
        name: 'oilCardBalanceExchangeList',
        component: () => import('@/views/bms/oilcardExchange/index'),
        meta: {title: '会员列表', icon: 'product-list'},
        hidden: true
      },
      ]
    },

  {
    path: '/pms',
    component: Layout,
    redirect: '/pms/product',
    name: 'pms',
    meta: {title: '商品', icon: 'product'},
    children: [{
      path: 'product',
      name: 'product',
      component: () => import('@/views/pms/product/index'),
      meta: {title: '积分商品', icon: 'product-list'}
    },
    {
      path: 'cashierProduct',
      name: 'cashierProduct',
      component: () => import('@/views/pms/product/indexCachier'),
      meta: {title: '金额列表', icon: 'product-list'}
    },
      {
        path: 'addProduct',
        name: 'addProduct',
        component: () => import('@/views/pms/product/add'),
        meta: {title: '添加商品', icon: 'product-add'},
        hidden: true
      },
      {
        path: 'updateProduct',
        name: 'updateProduct',
        component: () => import('@/views/pms/product/update'),
        meta: {title: '修改商品', icon: 'product-add'},
        hidden: true
      },
      {
        path: 'productCate',
        name: 'productCate',
        component: () => import('@/views/pms/productCate/index'),
        meta: {title: '商品分类', icon: 'product-cate'}
      },
      {
        path: 'addProductCate',
        name: 'addProductCate',
        component: () => import('@/views/pms/productCate/add'),
        meta: {title: '添加商品分类'},
        hidden: true
      },
      {
        path: 'updateProductCate',
        name: 'updateProductCate',
        component: () => import('@/views/pms/productCate/update'),
        meta: {title: '修改商品分类'},
        hidden: true
      },
      {
        path: 'productAttr',
        name: 'productAttr',
        component: () => import('@/views/pms/productAttr/index'),
        meta: {title: '商品类型', icon: 'product-attr'}
      },
      {
        path: 'productAttrList',
        name: 'productAttrList',
        component: () => import('@/views/pms/productAttr/productAttrList'),
        meta: {title: '商品属性列表'},
        hidden: true
      },
      {
        path: 'addProductAttr',
        name: 'addProductAttr',
        component: () => import('@/views/pms/productAttr/addProductAttr'),
        meta: {title: '添加商品属性'},
        hidden: true
      },
      {
        path: 'updateProductAttr',
        name: 'updateProductAttr',
        component: () => import('@/views/pms/productAttr/updateProductAttr'),
        meta: {title: '修改商品属性'},
        hidden: true
      },
      {
        path: 'brand',
        name: 'brand',
        component: () => import('@/views/pms/brand/index'),
        meta: {title: '品牌管理', icon: 'product-brand'}
      },
      {
        path: 'addBrand',
        name: 'addBrand',
        component: () => import('@/views/pms/brand/add'),
        meta: {title: '添加品牌'},
        hidden: true
      },
      {
        path: 'updateBrand',
        name: 'updateBrand',
        component: () => import('@/views/pms/brand/update'),
        meta: {title: '编辑品牌'},
        hidden: true
      },
      {
        path: 'integrationPromotion',
        name: 'integrationPromotion',
        component: () => import('@/views/pms/integrationAct/index'),
        meta: {title: '积分商品活动', icon: 'product-list'}
      },
      {
        path: 'addIntegrationPromotion',
        name: 'addIntegrationPromotion',
        component: () => import('@/views/pms/integrationAct/add'),
        meta: {title: '添加活动'},
        hidden: true
      },
      {
        path: 'updateIntegrationPromotion',
        name: 'updateIntegrationPromotion',
        component: () => import('@/views/pms/integrationAct/update'),
        meta: {title: '编辑活动'},
        hidden: true
      }
    ]
  },
  {
    path: '/oms',
    component: Layout,
    redirect: '/oms/order',
    name: 'oms',
    meta: {title: '订单', icon: 'order'},
    children: [
      {
        path: 'order',
        name: 'order',
        component: () => import('@/views/oms/order/index'),
        meta: {title: '订单列表', icon: 'product-list'}
      },
      {
        path: 'simpleOrder',
        name: 'simpleOrder',
        component: () => import('@/views/oms/simpleOrder/index'),
        meta: {title: '订单列表', icon: 'product-list'}
      },
      {
        path: 'orderDetail',
        name: 'orderDetail',
        component: () => import('@/views/oms/order/orderDetail'),
        meta: {title: '订单详情'},
        hidden:true
      },
      {
        path: 'deliverOrderList',
        name: 'deliverOrderList',
        component: () => import('@/views/oms/order/deliverOrderList'),
        meta: {title: '发货列表'},
        hidden:true
      },
      {
        path: 'orderSetting',
        name: 'orderSetting',
        component: () => import('@/views/oms/order/setting'),
        meta: {title: '订单设置', icon: 'order-setting'}
      },
      {
        path: 'returnApply',
        name: 'returnApply',
        component: () => import('@/views/oms/apply/index'),
        meta: {title: '退款申请处理', icon: 'order-return'}
      },
      {
        path: 'returnReason',
        name: 'returnReason',
        component: () => import('@/views/oms/apply/reason'),
        meta: {title: '退款原因设置', icon: 'order-return-reason'}
      },
      {
        path: 'returnApplyDetail',
        name: 'returnApplyDetail',
        component: () => import('@/views/oms/apply/applyDetail'),
        meta: {title: '退款原因详情'},
        hidden:true
      },
      {
        path: 'advertiseOrder',
        name: 'advertiseOrder',
        component: () => import('@/views/oms/order/advertiseOrderIndex'),
        meta: {title: '订单列表', icon: 'product-list'},
        hidden:true
      }
    ]
  },
  {
    path:'/messageHome',
    component: Layout,
    name: 'messageHome',
    meta: {title: '短信业务', icon: 'ums-admin'},
    children: [
      {
        path: 'messageList',
        name: 'messageList',
        component: () => import('@/views/bms/message/index'),
        meta: {title: '短信列表', icon: 'ums-admin'}
      },
      {
        path: 'messageStatics',
        name: 'messageStatics',
        component: () => import('@/views/bms/message/messageStatics'),
        meta: {title: '短信统计', icon: 'ums-admin'}
      },
	  {
	    path: 'messagePush',
	    name: 'messagePush',
	    component: () => import('@/views/bms/message/pushSetting'),
	    meta: {title: '短信推送', icon: 'ums-admin'},
      hidden:true
	  },
    {
      path: 'messageModelIndex',
      name: 'messageModelIndex',
      component: () => import('@/views/bms/message/modelIndex'),
      meta: {title: '发送模版', icon: 'ums-admin'},
      hidden:true
    },
	{
	  path: 'pushListPicker',
	  name: 'pushListPicker',
	  component: () => import('@/views/bms/message/pushListPicker'),
	  meta: {title: '短信推送', icon: 'ums-admin'},
	hidden:true
	},
    ],
  },
  {
    path:'/sms',
    component: Layout,
    redirect: '/sms/coupon',
    name: 'sms',
    meta: {title: '营销', icon: 'sms'},
    children: [
      // {
      //   path: 'flash',
      //   name: 'flash',
      //   component: () => import('@/views/sms/flash/index'),
      //   meta: {title: '秒杀活动列表', icon: 'sms-flash'}
      // },
      // {
      //   path: 'flashSession',
      //   name: 'flashSession',
      //   component: () => import('@/views/sms/flash/sessionList'),
      //   meta: {title: '秒杀时间段列表'},
      //   hidden:true
      // },
      // {
      //   path: 'selectSession',
      //   name: 'selectSession',
      //   component: () => import('@/views/sms/flash/selectSessionList'),
      //   meta: {title: '秒杀时间段选择'},
      //   hidden:true
      // },
      // {
      //   path: 'flashProductRelation',
      //   name: 'flashProductRelation',
      //   component: () => import('@/views/sms/flash/productRelationList'),
      //   meta: {title: '秒杀商品列表'},
      //   hidden:true
      // },
      {
        path: 'coupon',
        name: 'coupon',
        component: () => import('@/views/sms/coupon/index'),
        meta: {title: '优惠券列表', icon: 'sms-coupon'}
      },
      {
        path: 'addCoupon',
        name: 'addCoupon',
        component: () => import('@/views/sms/coupon/add'),
        meta: {title: '添加优惠券'},
        hidden:true
      },
      {
        path: 'updateCoupon',
        name: 'updateCoupon',
        component: () => import('@/views/sms/coupon/update'),
        meta: {title: '修改优惠券'},
        hidden:true
      },
      {
        path: 'couponHistory',
        name: 'couponHistory',
        component: () => import('@/views/sms/coupon/history'),
        meta: {title: '优惠券领取详情'},
        hidden:true
      },
      {
        path: 'couponGift',
        name: 'couponGift',
        component: () => import('@/views/sms/couponGift/index'),
        meta: {title: '礼品券列表', icon: 'sms-coupon'}
      },

      {
        path: 'addCouponGift',
        name: 'addCouponGift',
        component: () => import('@/views/sms/couponGift/add'),
        meta: {title: '添加优惠券'},
        hidden:true
      },
      {
        path: 'updateCouponGift',
        name: 'updateCouponGift',
        component: () => import('@/views/sms/couponGift/update'),
        meta: {title: '修改礼品券'},
        hidden:true
      },
      {
        path: 'couponGiftHistory',
        name: 'couponGiftHistory',
        component: () => import('@/views/sms/couponGift/history'),
        meta: {title: '礼品券领取详情'},
        hidden:true
      },

      {
        path: 'subJectHistory',
        name: 'subJectHistory',
        component: () => import('@/views/sms/subject/history'),
        meta: {title: '专题详情'},
        hidden:true
      },
      {
        path: 'couponPkg',
        name: 'couponPkg',
        component: () => import('@/views/sms/coupon/pkgIndex'),
        meta: {title: '优惠券包', icon: 'sms-coupon'}
      },
      {
        path: 'addCouponPkg',
        name: 'addCouponPkg',
        component: () => import('@/views/sms/coupon/addPkg'),
        meta: {title: '添加优惠券包', icon: 'sms-coupon'},
        hidden:true
      },
      {
        path: 'updateCouponPkg',
        name: 'updateCouponPkg',
        component: () => import('@/views/sms/coupon/updatePkg'),
        meta: {title: '编辑优惠券包', icon: 'sms-coupon'},
        hidden:true
      },

      // {
      //   path: 'brand',
      //   name: 'homeBrand',
      //   component: () => import('@/views/sms/brand/index'),
      //   meta: {title: '品牌推荐', icon: 'product-brand'}
      // },
      // {
      //   path: 'new',
      //   name: 'homeNew',
      //   component: () => import('@/views/sms/new/index'),
      //   meta: {title: '超值好物', icon: 'sms-new'}
      // },
      // {
      //   path: 'hot',
      //   name: 'homeHot',
      //   component: () => import('@/views/sms/hot/index'),
      //   meta: {title: '人气推荐', icon: 'sms-hot'}
      // },
      {
        path: 'subject',
        name: 'homeSubject',
        component: () => import('@/views/sms/subject/index'),
        meta: {title: '专题推荐', icon: 'sms-subject'}
      },
      {
        path: 'advertise',
        name: 'homeAdvertise',
        component: () => import('@/views/sms/advertise/index'),
        meta: {title: '广告列表', icon: 'sms-ad'}
      },
      {
        path: 'addAdvertise',
        name: 'addHomeAdvertise',
        component: () => import('@/views/sms/advertise/add'),
        meta: {title: '添加广告'},
        hidden:true
      },
      {
        path: 'updateAdvertise',
        name: 'updateHomeAdvertise',
        component: () => import('@/views/sms/advertise/update'),
        meta: {title: '编辑广告'},
        hidden:true
      },
      {
        path: 'oilActivity',
        name: 'oilActivity',
        component: () => import('@/views/bms/activity/index'),
        meta: {title: '加油优惠列表', icon: 'sms-coupon'}
      },
      {
        path: 'addOilActivity',
        name: 'addOilActivity',
        component: () => import('@/views/bms/activity/add'),
        meta: {title: '添加优惠'},
        hidden:true
      },
      {
        path: 'cachierProductActivity',
        name: 'cachierProductActivity',
        component: () => import('@/views/bms/cashierActivity/index'),
        meta: {title: '金额商品活动', icon: 'sms-coupon'}
      },
      {
        path: 'addCachierProductActivity',
        name: 'addCachierProductActivity',
        component: () => import('@/views/bms/cashierActivity/add'),
        meta: {title: '添加活动'},
        hidden:true
      },
      {
        path: 'updateCachierProductActivity',
        name: 'updateCachierProductActivity',
        component: () => import('@/views/bms/cashierActivity/update'),
        meta: {title: '编辑活动'},
        hidden:true
      },
      {
        path: 'updateOilActivity',
        name: 'updateOilActivity',
        component: () => import('@/views/bms/activity/update'),
        meta: {title: '编辑优惠'},
        hidden:true
      },
      {
        path: 'oilIntegralActivity',
        name: 'oilIntegralActivity',
        component: () => import('@/views/bms/integralActivity/index'),
        meta: {title: '加油送积分', icon: 'sms-coupon'}
      },
      {
        path: 'addOilIntegralActivity',
        name: 'addOilIntegralActivity',
        component: () => import('@/views/bms/integralActivity/add'),
        meta: {title: '添加配置'},
        hidden:true
      },
      {
        path: 'updateIntegralActivity',
        name: 'updateIntegralActivity',
        component: () => import('@/views/bms/integralActivity/update'),
        meta: {title: '编辑配置'},
        hidden:true
      }

    ]
  },
  {
    path:'/miniconfig',
    component: Layout,
    redirect: '/miniconfig/wxGroup',
    name: 'miniAppSms',
    meta: {title: '小程序客户端配置', icon: 'sms'},
    children: [
      {
        path: 'wxGroup',
        name: 'wxGroup',
        component: () => import('@/views/miniconfig/wxGroup/index'),
        meta: {title: '基础配置', icon: 'sms-coupon'}
      },
	  {
	    path: 'pushSetting',
	    name: 'pushSetting',
	    component: () => import('@/views/miniconfig/wxGroup/pushSetting'),
	    meta: {title: '推送配置', icon: 'sms-coupon'}
	  },
    {
      path: 'shareSetting',
      name: 'shareSetting',
      component: () => import('@/views/miniconfig/wxGroup/shareSetting'),
      meta: {title: '分享活动配置'},
      hidden:true
    },
    {
      path: 'oilOrderSetting',
      name: 'oilOrderSetting',
      component: () => import('@/views/miniconfig/wxGroup/oilOrderSetting'),
      meta: {title: '加油距离配置'},
      hidden:true
    },
    {
      path: 'oilCardSetting',
      name: 'oilCardSetting',
      component: () => import('@/views/miniconfig/wxGroup/oilCardSetting'),
      meta: {title: '充卡距离配置'},
      hidden:true
    },
    {
      path: 'shopShowSetting',
      name: 'shopShowSetting',
      component: () => import('@/views/miniconfig/wxGroup/shopShowSetting'),
      meta: {title: '油站展示配置'},
      hidden:true
    },
    {
      path: 'posOrderShowSetting',
      name: 'posOrderShowSetting',
      component: () => import('@/views/miniconfig/wxGroup/posOrderShowSetting'),
      meta: {title: '油站展示配置'},
      hidden:true
    },
    {
      path: 'divideAccountSetting',
      name: 'divideAccountSetting',
      component: () => import('@/views/miniconfig/wxGroup/DivideAccountSetting'),
      meta: {title: '分账配置'},
      hidden:true
    },
    {
      path: 'divideAccountShowSetting',
      name: 'divideAccountShowSetting',
      component: () => import('@/views/miniconfig/wxGroup/DivideAccountShowSetting'),
      meta: {title: '分账配置'},
      hidden:true
    },
    {
      path: 'payAccountList',
      name: 'payAccountList',
      component: () => import('@/views/miniconfig/wxGroup/payAccountList'),
      meta: {title: '银联账户列表'},
      hidden:true
    },
    {
      path: 'discountShow',
      name: 'discountShow',
      component: () => import('@/views/miniconfig/wxGroup/orderDiscountShowSetting'),
      meta: {title: '价格优惠显示'},
      hidden:true
    },
    {
      path: 'rateBalanceList',
      name: 'rateBalanceList',
      component: () => import('@/views/miniconfig/wxGroup/RateBalanceSetting'),
      meta: {title: '卡余额比例设置'},
      hidden:true
    },
    {
      path: 'InvoiceSetting',
      name: 'InvoiceSetting',
      component: () => import('@/views/miniconfig/wxGroup/InvoiceSetting'),
      meta: {title: '发票时长配置'},
      hidden:true
    },
    {
      path: 'OilCardChargeLimit',
      name: 'OilCardChargeLimit',
      component: () => import('@/views/miniconfig/wxGroup/CardChargeLimitSetting'),
      meta: {title: '充卡禁用配置'},
      hidden:true
    },
    {
      path: 'payTypeLimit',
      name: 'payTypeLimit',
      component: () => import('@/views/miniconfig/wxGroup/PayTypeLimitSetting'),
      meta: {title: '支付限制配置'},
      hidden:true
    }
    ]
  },
  {
    path:'/clientUserHome',
    component: Layout,
    name: 'clientUserHome',
    meta: {title: 'C端用户', icon: 'ums-admin'},
    children: [
      {
        path: 'wxUserList',
        name: 'wxUserList',
        component: () => import('@/views/clientuser/wxuser/index'),
        meta: {title: '小程序用户', icon: 'ums-admin'}
      },
      {
        path: 'shopUserList',
        name: 'shopUserList',
        component: () => import('@/views/clientuser/wxuser/shopUserList'),
        meta: {title: '油站用户', icon: 'ums-admin'}
      },
      {
        path: 'activeWxUserList',
        name: 'activeWxUserList',
        component: () => import('@/views/clientuser/wxuser/activeIndex'),
        meta: {title: '活跃用户', icon: 'ums-admin'}
      },
      {
        path: 'wxMpUserList',
        name: 'wxMpUserList',
        component: () => import('@/views/clientuser/wxuser/mpUserIndex'),
        meta: {title: '公众号用户', icon: 'ums-admin'}
      },
      {
        path: 'wxMpUserListPicker',
        name: 'wxMpUserListPicker',
        component: () => import('@/views/clientuser/wxuser/mpUserIndexPicker'),
        meta: {title: '公众号用户', icon: 'ums-admin'},
        hidden:true
      },
      {
        path: 'adminUserList',
        name: 'adminUserList',
        component: () => import('@/views/clientuser/wxuser/adminUserList'),
        meta: {title: 'C端管理员', icon: 'ums-admin'}
      },
      {
        path: 'wxUserListPicker',
        name: 'wxUserListPicker',
        component: () => import('@/views/clientuser/wxuser/userPicker'),
        meta: {title: '小程序用户', icon: 'ums-admin'},
        hidden:true
      },
      {
        path: 'appUserList',
        name: 'appUserList',
        component: () => import('@/views/clientuser/appuser/index'),
        meta: {title: 'app用户', icon: 'ums-admin'}
      },
      {
        path: 'wxUserInfo',
        name: 'wxUserInfo',
        component: () => import('@/views/clientuser/wxuser/userDetail'),
        meta: {title: '用户详情'},
        hidden:true
      }
    ],
  },
  {
    path:'/ums',
    component: Layout,
    redirect: '/ums/admin',
    name: 'ums',
    meta: {title: '权限', icon: 'ums'},
    children: [
      {
        path: 'admin',
        name: 'admin',
        component: () => import('@/views/ums/admin/index'),
        meta: {title: '管理后台用户', icon: 'ums-admin'}
      },
      {
        path: 'role',
        name: 'miniapp',
        component: () => import('@/views/ums/miniapp/index'),
        meta: {title: '小程序用户', icon: 'ums-role'}
      },
      {
        path: 'role',
        name: 'role',
        component: () => import('@/views/ums/miniapp/index'),
        meta: {title: '小程序用户', icon: 'ums-role'}
      },
      {
        path: 'allocMenu',
        name: 'allocMenu',
        component: () => import('@/views/ums/role/allocMenu'),
        meta: {title: '分配菜单'},
        hidden: true
      },
      {
        path: 'allocResource',
        name: 'allocResource',
        component: () => import('@/views/ums/role/allocResource'),
        meta: {title: '分配资源'},
        hidden: true
      },
      {
        path: 'menu',
        name: 'menu',
        component: () => import('@/views/ums/menu/index'),
        meta: {title: '菜单列表', icon: 'ums-menu'}
      },
      {
        path: 'addMenu',
        name: 'addMenu',
        component: () => import('@/views/ums/menu/add'),
        meta: {title: '添加菜单'},
        hidden: true
      },
      {
        path: 'updateMenu',
        name: 'updateMenu',
        component: () => import('@/views/ums/menu/update'),
        meta: {title: '修改菜单'},
        hidden: true
      },
      {
        path: 'resource',
        name: 'resource',
        component: () => import('@/views/ums/resource/index'),
        meta: {title: '资源列表', icon: 'ums-resource'}
      },
      {
        path: 'resourceCategory',
        name: 'resourceCategory',
        component: () => import('@/views/ums/resource/categoryList'),
        meta: {title: '资源分类'},
        hidden: true
      }
    ]
  },
  {path: '*', redirect: '/404', hidden: true}
]

export default new Router({
  // mode: 'history', //后端支持可开
  scrollBehavior: () => ({y: 0}),
  routes: constantRouterMap
})



// WEBPACK FOOTER //
// ./src/router/index.js